import { push } from 'connected-react-router'
import React, { FC, useEffect } from 'react'

import CustomButton from '../../components/UI/Buttons/CustomButton'
import SignoutIcon from '../../components/UI/Icons/SignOut'

import { useDispatch, useSelector } from '../../store'
import { logOutThunk } from '../../store/auth/thunks'
import {
  hideTransparentPreloaderAction,
  showTransparentPreloaderAction
} from '../../store/transparentPreloader/slice'
import { NON_AUTH_ROUTE } from '../App/routes'

import './NoProject.scss'

interface CalendarProps {}

const NoProject: FC<CalendarProps> = (props) => {
  const dispatch = useDispatch()
  const { user, project } = useSelector((state) => ({
    user: state.auth.user,
    project: state.project.currentProject
  }))

  const signOut = async () => {
    dispatch(showTransparentPreloaderAction())
    await dispatch(logOutThunk())
    dispatch(push(NON_AUTH_ROUTE.LOGIN))
    dispatch(hideTransparentPreloaderAction())
  }

  useEffect(() => {
    if (user && project.id) {
      dispatch(push(NON_AUTH_ROUTE.LOGIN))
    }
  }, [project, user, dispatch])

  return (
    <div className='without-project'>
      <div className='without-project__text'>
        {user?.name}, currently, you don't have access to any of the projects of the agency. Please
        wait for an invitation or contact your agency admin to get the access.
      </div>
      <div className='without-project__action'>
        <CustomButton button='add-subtle' onClick={signOut}>
          <SignoutIcon />
          Sign Out
        </CustomButton>
      </div>
    </div>
  )
}

export default NoProject
